package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_06_30_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It is time to report into The Peers and Dirk’s People. Caper, Falorn, Tuesday, and Annette search the cavern. And find treasure. Goram sends a succinct report. Our heroes spend a couple of hours dividing up loot and identifying. Our heroes return to the boats and head downstream. After 4 hours of travel just after midday, they see a shrine to Silpion (Goddess of All Water) on the left bank of the river.")
    }
}
